export function mapLogosToGrid(logos = [], rows = 12, cols = 20) {
  const grid = [];
  const logosCopy = [...logos];
  const logoCount = logos.length;
  const aspect = 16 / 9;
  const logosX = Math.ceil(Math.sqrt(logoCount * aspect));
  const logosY = Math.ceil(logoCount / logosX);

  const startX = 0 - Math.floor(logosX / 2);
  const startY = 0 - Math.floor(logosY / 2);
  const endX = startX + logosX;
  const endY = startY + logosY;

  for (let y = startY; y < endY; y++) {
    for (let x = startX; x < endX; x++) {
      const logo = logos.shift();
      if (logo) {
        grid[x] = grid[x] || {};
        grid[x][y] = logo;
      }
    }
  }

  const restStartX = 0 - Math.floor(cols / 2);
  const restStartY = 0 - Math.floor(rows / 2);
  const restEndX = restStartX + cols;
  const restEndY = restStartY + rows;

  for (let y = restStartY; y < restEndY; y++) {
    for (let x = restStartX; x < restEndX; x++) {
      const logo = logosCopy[Math.floor(Math.random() * logoCount)];
      if (logo) {
        grid[x] = grid[x] || {};
        if (!grid[x][y]) {
          grid[x][y] = logo;
        }
      }
    }
  }

  return grid;
}
